export default __webpack_public_path__ + "8755ad917e5e6e7eeca55403285f4f6c.png";